import React, { useEffect, useState } from "react";

/**
 * Live status ticker across the very top of the page.
 * Shows location, current IST time, availability, and an index counter.
 */
export default function TopTicker() {
  const [now, setNow] = useState("");

  useEffect(() => {
    const fmt = () => {
      try {
        const d = new Date();
        const t = d.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          timeZone: "Asia/Kolkata",
          hour12: false,
        });
        setNow(t);
      } catch {
        setNow("—");
      }
    };
    fmt();
    const i = setInterval(fmt, 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="ticker">
      <div><span className="dot" /> Available — advisory &amp; keynotes · 2026</div>
      <div className="hidden md:block">IST · {now}</div>
      <div>Gujarat, IN — remote worldwide</div>
    </div>
  );
}
